import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { ApiServiceServerless } from '../../../xhr_libs';
import AddEntityActionButtons from '../../forms/AddEntityActionButtons';

export default function AddPlugCustomTemplateModal(props) {
  const {
    show,
    onHide,
    showToast,
    setTemplates,
    setActiveTemplateId,
    organizationId,
  } = props;

  const [templateName, setTemplateName] = useState('');
  const [templateProvider, setTemplateProvider] = useState('');

  const [disabled, setDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (templateName && templateProvider) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [templateName, templateProvider]);

  const addTemplate = (e) => {
    e.preventDefault();
    setIsLoading(true);
    ApiServiceServerless.post(
      `/custom_templates`,
      {
        name: templateName,
        template_type: 'plug',
        utility_provider: templateProvider,
        organization_id: organizationId,
      },
      { authorization_id: organizationId }
    )
      .then((res) => {
        setTemplates((prev) => [...prev, res.data]);
        setActiveTemplateId(res.data.id);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        onHide();
        setIsLoading(false);
        resetModal();
      });
  };

  const resetModal = () => {
    setTemplateName('');
    setTemplateProvider('');
  };

  useEffect(() => {
    if (show) {
      resetModal();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>Add Template</Modal.Header>
      <Form onSubmit={addTemplate}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              {'Template Name'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setTemplateName(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              {'Template Utility Provider'}
              <span className='text-warning font-weight-bold pl-1'>*</span>
            </Form.Label>
            <Form.Row>
              <Form.Control
                required
                placeholder=''
                onChange={(e) => setTemplateProvider(e.target.value)}
              />
            </Form.Row>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <AddEntityActionButtons
            onCancel={onHide}
            submitDisabled={disabled}
            isSubmitting={isLoading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
